(() => {
  if (window.hsReviewsPopupStyled) return;
  window.hsReviewsPopupStyled = true;
  // Only an explicit click may expose the global review panel.
  document.body.classList.remove('hs-reviews-user-open');
  document.addEventListener('click', event => {
    if (event.target.closest?.('.jdgm-revs-tab-btn')) document.body.classList.add('hs-reviews-user-open');
  }, true);
  const paginationStates = new WeakMap();
  function enhancePagination(popup) {
    const body = popup.querySelector('.jdgm-revs-tab__reviews');
    const pager = popup.querySelector('.jdgm-paginate');
    if (!body || !pager) return;
    let state = paginationStates.get(popup);
    if (!state) {
      state = { pending: null, timer: null, reset: false };
      paginationStates.set(popup, state);
      const reset = event => {
        if (!event.target.closest('.jdgm-sort-dropdown,.jdgm-subtab__name,.jdgm-histogram__row')) return;
        clearTimeout(state.timer);
        state.pending = null;
        state.reset = true;
        state.beforeFilter = [...body.querySelectorAll('.jdgm-rev')].map(el => el.dataset.reviewId).join('|');
        body.removeAttribute('aria-busy');
        setTimeout(() => { state.reset = false; enhancePagination(popup); }, 2000);
      };
      popup.addEventListener('change', reset);
      popup.addEventListener('click', reset, true);
    }
    const page = Number(pager.querySelector('.jdgm-curt')?.dataset.page || 1);
    const reviews = [...body.querySelectorAll(':scope > .jdgm-rev')];
    const signature = reviews.map(el => el.dataset.reviewId).join('|');
    let button = popup.querySelector('.hs-reviews-load-more');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'hs-reviews-load-more';
      button.textContent = 'Carregar mais';
      button.addEventListener('click', () => {
        if (state.pending || state.reset) return;
        const currentBody = popup.querySelector('.jdgm-revs-tab__reviews');
        const next = popup.querySelector('.jdgm-paginate__next-page');
        if (!currentBody || !next) return;
        const previous = [...currentBody.querySelectorAll(':scope > .jdgm-rev')];
        const scroller = popup.querySelector('.jdgm-revs-tab__content');
        state.pending = { page: Number(next.dataset.page), previous, scroller, scrollTop: scroller?.scrollTop || 0 };
        currentBody.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.textContent = 'Carregando…';
        state.timer = setTimeout(() => {
          if (!state.pending) return;
          state.pending = null;
          currentBody.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = 'Tentar carregar mais';
        }, 15000);
        next.click();
      });
      pager.after(button);
    } else if (button.previousElementSibling !== pager) pager.after(button);
    if (state.reset && page === 1 && signature && signature !== state.beforeFilter) state.reset = false;
    if (state.pending && page === state.pending.page && reviews.length && reviews.some(el => !state.pending.previous.includes(el))) {
      const pending = state.pending;
      clearTimeout(state.timer);
      state.pending = null;
      const seen = new Set(reviews.map(el => el.dataset.reviewId));
      const previous = pending.previous.filter(el => !seen.has(el.dataset.reviewId));
      body.prepend(...previous);
      body.removeAttribute('aria-busy');
      if (pending.scroller) {
        pending.scroller.scrollTop = pending.scrollTop;
        requestAnimationFrame(() => { pending.scroller.scrollTop = pending.scrollTop; });
      }
    }
    const next = pager.querySelector('.jdgm-paginate__next-page');
    button.hidden = !next && !state.pending;
    button.disabled = !!state.pending || state.reset;
    const label = state.pending ? 'Carregando…' : 'Carregar mais';
    if (button.textContent !== label) button.textContent = label;
    pager.setAttribute('aria-hidden', 'true');
    pager.querySelectorAll('[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
  }

  function enhance() {
    const widget = document.querySelector('.jdgm-revs-tab');
    const trigger = widget?.querySelector('.jdgm-revs-tab-btn');
    if (trigger) {
      trigger.setAttribute('aria-label', 'Abrir avaliações de clientes');
    }
    const wrapper = widget?.querySelector('.jdgm-revs-tab__wrapper');
    if (wrapper && !wrapper.classList.contains('jdgm-show')) document.body.classList.remove('hs-reviews-user-open');
    const popup = document.querySelector('.jdgm-revs-tab__main');
    if (!popup) return;
    enhancePagination(popup);
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Avaliações de clientes');
    const close = popup.querySelector('.jdgm-close-ico');
    if (close) {
      close.setAttribute('aria-label', 'Fechar avaliações');
      close.setAttribute('tabindex', '0');
      if (!close.dataset.hsKeyboard) {
        close.dataset.hsKeyboard = 'true';
        close.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); }
        });
      }
    }
    const open = wrapper?.classList.contains('jdgm-show') && document.body.classList.contains('hs-reviews-user-open');
    trigger?.setAttribute('aria-expanded', String(!!open));
    if (open && !popup.dataset.hsFocusOpen) {
      popup.dataset.hsFocusOpen = 'true';
      close?.focus({preventScroll:true});
    } else if (!open && popup.dataset.hsFocusOpen) {
      delete popup.dataset.hsFocusOpen;
      trigger?.focus({preventScroll:true});
    }
    if (!popup.dataset.hsFocusTrap) {
      popup.dataset.hsFocusTrap = 'true';
      popup.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...popup.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
        const first=items[0], last=items[items.length-1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
    }
    // Wait for an open, populated widget. Changing a select during setup can
    // change its label before Judge.me attaches the handler that loads reviews.
    const preferredSort = window.HolyTheme?.hs_reviews_sort || 'pictures-first';
    const title = popup.querySelector('.jdgm-revs-tab__title');
    if (title && title.textContent !== window.HolyTheme?.hs_reviews_title && window.HolyTheme?.hs_reviews_title) title.textContent = window.HolyTheme.hs_reviews_title;
    const tab = document.querySelector('.jdgm-revs-tab-btn');
    if (tab && window.HolyTheme?.hs_reviews_label && tab.textContent !== window.HolyTheme.hs_reviews_label) tab.textContent = window.HolyTheme.hs_reviews_label;
    const sorting = popup.querySelector('.jdgm-sort-dropdown:has(option[value="pictures-first"])');
    const ready = popup.closest('.jdgm--done-setup-widget') && popup.getClientRects().length && popup.querySelector('.jdgm-rev');
    if (ready && sorting && sorting.querySelector('option[value="pictures-first"]') && !popup.hasAttribute('data-hs-photo-first')) {
      popup.setAttribute('data-hs-photo-first', 'pending');
      setTimeout(() => {
        if (!popup.isConnected || !popup.getClientRects().length) {
          popup.removeAttribute('data-hs-photo-first');
          return;
        }
        popup.setAttribute('data-hs-photo-first', 'true');
        if (sorting.value === 'most-recent' || sorting.value === 'pictures-first') {
          sorting.value = preferredSort;
          sorting.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 150);
    }
    popup.querySelectorAll('.jdgm-histogram__frequency,.jdgm-all-reviews-text,.jdgm-subtab__name').forEach(el => {
      for (const node of el.childNodes) {
        if (node.nodeType !== Node.TEXT_NODE) continue;
        const next = node.textContent.replace(/(?<![\d.,])\d{4,}(?![\d.,])/g, n => Number(n).toLocaleString('pt-BR'));
        if (next !== node.textContent) node.textContent = next;
      }
    });
    const score = popup.querySelector('.jdgm-all-reviews-rating');
    if (score && !score.hasAttribute('data-hs-score')) {
      const value = Number(score.dataset.score);
      if (Number.isFinite(value)) score.dataset.hsScore = value.toFixed(1).replace('.', ',');
    }
    const rows = [...popup.querySelectorAll('.jdgm-histogram__row[data-frequency]')];
    rows.forEach(row => {
      const star = row.querySelector('.jdgm-histogram__star');
      const frequency = row.querySelector('.jdgm-histogram__frequency');
      if (star && !star.hasAttribute('data-hs-label')) star.dataset.hsLabel = row.dataset.rating + ' ★';
      if (frequency && !frequency.hasAttribute('data-hs-percent')) frequency.dataset.hsPercent = row.dataset.percentage + '% · ';
    });
    const total = rows.reduce((n,row) => n + Number(row.dataset.frequency || 0), 0);
    const good = rows.filter(row => Number(row.dataset.rating) >= 4).reduce((n,row) => n + Number(row.dataset.frequency || 0), 0);
    const header = popup.querySelector('.jdgm-revs-tab__url');
    if (total > 0 && header && !header.querySelector('.hs-popup-recommend')) {
      const text = document.createElement('span');
      text.className = 'hs-popup-recommend';
      text.textContent = Math.floor(good / total * 100) + '% deram 4 ou 5 estrelas';
      header.append(text);
    }
  }
  let queued = false;
  let observingPopup = false;
  const observer = new MutationObserver(() => {
    const widget = document.querySelector('.jdgm-revs-tab');
    if (widget && !observingPopup) {
      observer.disconnect();
      observer.observe(widget, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style'] });
      observingPopup = true;
    }
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  });
  const initialWidget = document.querySelector('.jdgm-revs-tab');
  if (initialWidget) {
    observer.observe(initialWidget, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style'] });
    observingPopup = true;
  } else observer.observe(document.body, { childList:true, subtree:true });
  enhance();
})();
